import { observable, action } from 'mobx';
import { persist } from 'mobx-persist';
import flatten from 'utils/flattenArray';
export default class TestProgressModel {
  @persist
  @observable
  trials;

  @persist
  @observable
  trialIndex;

  @persist
  @observable
  testItemIndex;

  @persist('list')
  @observable
  results;

  constructor(trials) {
    this.trials = trials;
    this.trialIndex = 0;
    this.results = [];
    this.testItemIndex = 0;
  }

  @action
  setResult(result) {
    this.results[this.trialIndex] = result;
    this.trialIndex++;
  }

  getResult() {
    return this.results;
  }

  toJS() {
    return {
      trials: this.trials,
      trialIndex: this.trialIndex,
      testItemIndex: this.testItemIndex,
      results: this.results.toJS()
    };
  }
}
